import {Component, ChangeDetectionStrategy, inject, Output, EventEmitter, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Observable } from 'rxjs';

import { StatisticsStateService } from '../../controller/statistics-state.service';
import {SearchTabTeamComponent} from "../search-tab-team/search-tab-team.component";
import {SearchTabMatchComponent} from "../search-tab-match/search-tab-match.component";
import {SearchTabPlayerComponent} from "../search-tab-player/search-tab-player.component";

@Component({
  selector: 'app-statistics-tabs',
  templateUrl: './statistics-tabs.component.html',
  styleUrls: ['./statistics-tabs.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatTabsModule,
    MatProgressBarModule,
    SearchTabTeamComponent,
    SearchTabMatchComponent,
    SearchTabPlayerComponent,
  ]
})
export class StatisticsTabsComponent {

  @Output() tabChanged = new EventEmitter<number>();
  @Input() selectedTabIndex: number = 0;
  @Input() statsMode: 'actas' | 'ia' = 'actas';
  private state = inject(StatisticsStateService);
  public isLoadingData$: Observable<boolean>;

  constructor() {
    this.isLoadingData$ = this.state.isLoadingData$;
  }

  /**
   * Se dispara cuando el usuario cambia de pestaña.
   * @param tabIndex 0: Equipo, 1: Partido, 2: Jugador
   */
  public onTabChange(tabIndex: number): void {
    this.tabChanged.emit(tabIndex);

  }
}
